import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import get from 'lodash/get';

import Meta from 'Components/Utility/SEO/Meta';
import NoIndex from 'Components/Utility/SEO/NoIndex';
import Order from 'Components/Order/Order';
import { sendConfirmEmail, checkConfirmed } from 'Redux/ducks/auth';
import { getSingleOrder } from 'Redux/ducks/orders';
import { toggleLoginModal } from 'Redux/ducks/modal';
import NotFoundOrder from 'Containers/Order/NotFoundOrder';
import Loading from 'Components/Utility/Loading';

function OrderContainer({
  email,
  email_confirmed: emailConfirmed,
  failed_check: failedCheck,
  sendConfirmEmail: _sendConfirmEmail,
  checkConfirmed: _checkConfirmed,
  toggleLoginModal: _toggleLoginModal,
  authenticated,
  location,
  intl,
}) {
  const [order, setOrder] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  const orderId = get(location, 'pathname', '').split('/')[2];

  useEffect(() => {
    if (!authenticated) {
      _toggleLoginModal();
    }
  }, [_toggleLoginModal, authenticated]);

  const fetchOrder = (id) => {
    setOrder(null);
    setNotFound(false);
    setIsLoading(true);

    getSingleOrder(id).then((data) => {
      setOrder(data);
      setIsLoading(false);
    }).catch(() => {
      setNotFound(true);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    fetchOrder(orderId);
  }, [orderId]);

  if (isLoading) {
    return <Loading />;
  }

  if (notFound) {
    return <NotFoundOrder />;
  }

  if (!authenticated) {
    return (
      <div className="account-content">
        <h1>
          <FormattedMessage id="order.unauthenticated" defaultMessage="Sign in to view your order" />
        </h1>
      </div>
    );
  }

  const { formatMessage } = intl;

  const messages = defineMessages({
    title: {
      id: 'order.seotitle',
      defaultMessage: 'Order',
    },
  });

  return (
    <div>
      <Meta brandTitle title={formatMessage(messages.title)} />
      <NoIndex />
      <Order
        order={order}
        email={email}
        emailConfirmed={emailConfirmed}
        sendConfirmEmail={_sendConfirmEmail}
        checkConfirmed={_checkConfirmed}
        failedCheck={failedCheck}
        setOrder={setOrder}
      />
    </div>
  );
}

OrderContainer.propTypes = {
  email: PropTypes.string,
  email_confirmed: PropTypes.bool,
  failed_check: PropTypes.bool,
  sendConfirmEmail: PropTypes.func.isRequired,
  checkConfirmed: PropTypes.func.isRequired,
  authenticated: PropTypes.bool,
  toggleLoginModal: PropTypes.func,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

OrderContainer.defaultProps = {
  failed_check: false,
  email: '',
  email_confirmed: false,
  authenticated: false,
  toggleLoginModal: () => {},
  location: {
    pathname: '',
  },
};

const mapStateToProps = ({
  auth: {
    email, email_confirmed, sentEmail, failed_check, authenticated, // eslint-disable-line camelcase
  },
  router: { location },
}) => ({
  email,
  email_confirmed,
  sentEmail,
  failed_check,
  authenticated,
  location,
});

const mapDispatchToProps = {
  sendConfirmEmail,
  checkConfirmed,
  toggleLoginModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(OrderContainer));
